import type { AssetsShareCreateSchema } from '@iconik-io/iconik-api/src/services/assets';
import type { UserRoles } from '@iconik-io/shared-lib/src/utils/roles';

import { hasUploadRoles } from '../../panels/uploads/uploader_roles';

export type ShareFieldKey = keyof AssetsShareCreateSchema;

export const hasShareFieldRoles = (
  fieldKey: ShareFieldKey,
  roles: UserRoles,
) => {
  switch (fieldKey) {
    case 'allow_download':
      return roles.canReadFiles && roles.webCanDownloadOriginal;

    case 'allow_download_proxy':
      return roles.canReadProxies && roles.webCanDownloadProxy;

    case 'upload_storage_id':
    case 'allow_upload':
      return roles.canCreateSharesToUpload && hasUploadRoles(roles);

    case 'allow_custom_actions':
      return roles.canReadCustomActions;

    case 'allow_comments':
      return (
        roles.canReadSegments &&
        roles.canWriteSegments &&
        roles.canCreateSegments
      );

    case 'allow_approving_comments':
      return roles.canReadSegments && roles.canWriteSegments;

    case 'allow_view_versions':
      return roles.webCanViewVersions;

    case 'allow_setting_approve_status':
      return roles.canWriteApprovalStatus;

    case 'allow_user_search_for_mentions':
      return roles.canReadSegments && roles.canWriteSegments;

    case 'allow_view_transcriptions':
      return roles.canReadSegments && roles.canReadTranscriptions;

    case 'show_watermark':
      return true;

    case 'show_existing_comments':
      return true;

    case 'allow_sync':
      return true;

    default:
      return false;
  }
};

export const hasShareMultiFieldRoles = (
  fieldKeys: ShareFieldKey[],
  roles: UserRoles,
) => fieldKeys.every((fieldKey) => hasShareFieldRoles(fieldKey, roles));
